/** @format */
import { Pipe, PipeTransform } from '@angular/core';
import { LocalizedString } from 'common-typescript/types';
import { CourseUnitRealisationNameService, PartialCUR } from 'sis-common';

@Pipe({
    name: 'courseUnitRealisationFullName',
    standalone: false,
})
export class CourseUnitRealisationFullNamePipe implements PipeTransform {
    constructor(private courseUnitRealisationNameService: CourseUnitRealisationNameService) {}

    transform(value: PartialCUR): LocalizedString {
        if (!value) {
            return null;
        }
        return this.courseUnitRealisationNameService.generateFullName(value);
    }
}
